module.exports = __webpack_public_path__ + "img/0Q3A3375_L_BlackMatted_MockedUp.3cf3afc3.jpg";